import React from 'react';
import DashboardV2MiniCard from './DashboardV2MiniCard';
import DashboardV2VendeurLabel from './DashboardV2VendeurLabel';
import { formatDashboardNumber, getRowLineClass } from '../../../utils/dashboardV2Utils';

const DashboardV2StatutsRows = ({ rows = [], colorByName = {} }) => {
  if (!rows.length) {
    return <div className="p-3 text-muted">Aucune donnée disponible.</div>;
  }

  return rows.map((row, idx) => (
    <div key={`${row.vendeur}-${idx}`} className={`v2-row-line ${getRowLineClass(row)}`}>
      <DashboardV2VendeurLabel vendeur={row.vendeur} rowType={row._row_type} colorByName={colorByName} />
      <div className="v2-cards-grid cols-5">
        <DashboardV2MiniCard label="Nouveaux" value={formatDashboardNumber(row.nouveau_client)} bgClass="v2-bg-nouveau" />
        <DashboardV2MiniCard label="Fidélisés" value={formatDashboardNumber(row.fidelisee)} bgClass="v2-bg-fidelisee" />
        <DashboardV2MiniCard label="Passives" value={formatDashboardNumber(row.passive)} bgClass="v2-bg-passive" />
        <DashboardV2MiniCard label="Dormantes" value={formatDashboardNumber(row.dormante)} bgClass="v2-bg-dormante" />
        <DashboardV2MiniCard label="Anciens" value={formatDashboardNumber(row.anciens_clients)} bgClass="v2-bg-anciens" />
      </div>
    </div>
  ));
};

export default DashboardV2StatutsRows;
